import { Collection } from '../types'

function getCollectionOrEmptyObject<T>(
  collection: Collection<T> | undefined
): Collection<T> {
  if (collection === undefined) {
    return {}
  }
  return collection
}

export default getCollectionOrEmptyObject
